import { type PartialDeep } from 'type-fest';

import { type CanvasElementFrom, type PropsOf } from '@blaze-runtime/engine-domain';

import { getSourceTransforms } from '../../canvas-elements/element-model/transformations';

type DatetimeInputFieldElement = CanvasElementFrom<'datetimeInput'>;
type DatetimeInputFieldProps = PartialDeep<PropsOf<'datetimeInput'>>;

function transformTextFieldToDatetimeInput(
  source: CanvasElementFrom<'textField'>,
): DatetimeInputFieldElement {
  const props: PartialDeep<PropsOf<'textField'>> = source.props || {};
  const propsT = getSourceTransforms<'textField', 'datetimeInput'>(source, 'datetimeInput');
  const newProps: DatetimeInputFieldProps = {
    content: {
      title: {
        enabled: props.content?.title?.enabled,
        label: props.content?.title?.label,
        position: props.content?.title?.position,
        align: props?.content?.title?.align?.horizontal ?? propsT?.content?.title?.align,
        width: props.content?.title?.width,
        icon: props.content?.title?.icon,
        iconPosition: props.content?.title?.iconPosition,
        tooltip: props.content?.title?.tooltip,
      },
      date: {
        enabled: propsT?.content?.date?.enabled,
        format: propsT?.content?.date?.format,
        min: propsT?.content?.date?.min,
        max: propsT?.content?.date?.max,
        defaultValue: propsT?.content?.date?.defaultValue,
      },
      time: {
        enabled: propsT?.content?.time?.enabled,
        format: propsT?.content?.time?.format,
        min: propsT?.content?.time?.min,
        max: propsT?.content?.time?.max,
      },
    },
    style: {
      fontSize: props.style?.fontSize,
      fontFamily: props.style?.fontFamily,
      lineHeight: props.style?.lineHeight,
      general: {
        title: props.style?.general?.title,
        accent: props.style?.general?.accent,
      },
      input: {
        value: props.style?.input?.value,
        fill: props.style?.input?.fill,
        border: props.style?.input?.border,
        radius: props.style?.input?.radius,
      },
    },
    transforms: {
      textField: {
        content: {
          title: {
            align: props?.content?.title?.align,
          },
          input: {
            placeholder: props?.content?.input?.placeholder,
            format: props.content?.input?.format,
            precision: props.content?.input?.precision,
            currency: props.content?.input?.currency,
          },
          container: {
            overflow: props.content?.container?.overflow,
          },
        },
        style: {
          inputFont: {
            style: props.style?.inputFont?.style,
            fontFamily: props.style?.inputFont?.fontFamily,
            fontSize: props.style?.inputFont?.fontSize,
            lineHeight: props.style?.inputFont?.lineHeight,
          },
        },
      } as PartialDeep<PropsOf<'textField'>>,
    },
  };

  // TODO: fix type
  return { props: newProps } as any;
}

export const transformToDatetimeInput = {
  transformTextFieldToDatetimeInput,
};
